document.addEventListener('DOMContentLoaded', function () {
    landingProductsSlider();
    landingDoctorSlider();
    landingClinicalStudiesSlider();
})
function landingProductsSlider(){

    const containers = document.querySelectorAll('.js-landing-products-with-text-slider');
    if (!containers) return;
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper not found — include Swiper JS/CSS before this script.');
        return;
    }
    containers.forEach(slider=>{
        // init
        const swiper = new Swiper(slider, {
            slidesPerView: 1.5,
            spaceBetween: 15,
            loop: true,
            speed: 800,
            pagination: {
                el: slider.querySelector('.landing-products-with-text-slider-pagination'),
                clickable: true
            },
            breakpoints: {
                550: { spaceBetween: 15, slidesPerView: 2.4, },
                768: { spaceBetween: 15, slidesPerView: 1,  },
                1024: { spaceBetween: 15, slidesPerView: 2,  },
                1440: { spaceBetween: 42, slidesPerView: 2,  }
            },
        });
        if(window.matchMedia('(min-width: 768px)').matches){
            swiper.slideTo(1);
        }
    })

}
function landingDoctorSlider(){

    const containers = document.querySelectorAll('.js-lading-doctor-slider');
    if (!containers) return;
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper not found — include Swiper JS/CSS before this script.');
        return;
    }
    containers.forEach(slider=>{
        // init
        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 15,
            loop: true,
            speed: 800,
            navigation: {
                nextEl: slider.querySelector('.lading-doctor-slider-next'),
                prevEl: slider.querySelector('.lading-doctor-slider-prev'),
            },
        });

    })
}
function landingClinicalStudiesSlider(){

    const containers = document.querySelectorAll('.js-landing-clinical-studies-slider');
    if (!containers) return;
    if (typeof Swiper === 'undefined') {
        console.warn('Swiper not found — include Swiper JS/CSS before this script.');
        return;
    }
    containers.forEach(slider=>{
        // init
        const swiper = new Swiper(slider, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            simulateTouch: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            loop: true,
            speed: 800,
            pagination: {
                el: slider.querySelector('.landing-clinical-studies-slider-pagination'),
                clickable: true
            },

        });

    })

}
